/* eslint-disable no-param-reassign, no-unused-vars, no-unreachable */

/* global translation */

const paletteBuilder = () => {
  const paletteItems = () => Array.from(document.querySelectorAll('.palette-item'));


  const slots = (classes = '') => Array.from(document.querySelectorAll(`.slot.empty${classes}:not(.hidden)`));


  const firstLoad = () => {
    if (localStorage.paletteBuilderViewed) {
      return;
    }

    const storage = localStorage.paletteBuilderItems;
    if (storage) {
      return;
    }

    document.body.classList.add('first-timer');
  };
  firstLoad();


  const checkIfItemsAdded = () => {
    const filledSlots = Array.from(document.querySelectorAll('.palette-box .slot:not(.empty,.large-second)'));
    if (filledSlots.length > 0) {
      document.body.classList.add('have-items-in-builder');
    } else {
      document.body.classList.remove('have-items-in-builder');
    }
  };


  const setShareUrl = (size, productIds) => {
    const inputUrlField = document.querySelector('input#palette-builder-share-url-field');
    const url = new URL(inputUrlField.dataset.baseUrl);

    if (size) {
      url.searchParams.set('size', size);
    }
    if (productIds.length > 0) {
      url.searchParams.set('shades', productIds.join(','));
    }

    inputUrlField.value = url.href;
  };


  const getLocalStorage = () => {
    const storage = localStorage.paletteBuilderItems;
    if (!storage) {
      return;
    }

    const storedNames = JSON.parse(localStorage.paletteBuilderItems);

    if (storedNames) {
      if (storedNames.size) {
        const sizeButton = document.querySelector(`.size-option-wrapper .choose-size.${storedNames.size}-size`);
        if (sizeButton) {
          sizeButton.click();
        }
      }

      if (storedNames.productIds) {
        storedNames.productIds.forEach((productId) => {
          const shade = document.querySelector(`.palette-items [data-product-id="${productId}"]`);
          if (shade) {
            shade.click();
          }
        });
      }
    }
  };
  // setTimeout(getLocalStorage, 20);


  const setLocalStorage = () => {
    setTimeout(() => {
      const { size } = document.querySelector('.size-option-wrapper .choose-size.selected').dataset;
      const filledSlots = Array.from(document.querySelectorAll('.palette-box .slot:not(.empty,.large-second)'));

      const productIds = [];


      if (filledSlots) {
        filledSlots.forEach((slot) => {
          productIds.push(slot.dataset.productId);
        });
      }

      const toStore = {
        size,
        productIds,
      };

      localStorage.paletteBuilderViewed = 1;
      localStorage.paletteBuilderItems = JSON.stringify(toStore);

      setShareUrl(size, productIds);
    }, 20);
  };


  const buildImagesFromSkeleton = () => {
    const imageSkeletons = Array.from(document.querySelectorAll('.skeleton-box.skeleton-image'));

    if (imageSkeletons) {
      imageSkeletons.forEach((imageSkeleton) => {
        if (!imageSkeleton) {
          return;
        }

        const { file, size, productIds } = imageSkeleton.dataset;
        let { checked } = imageSkeleton.dataset;

        if (!file) {
          return;
        }

        if (checked) {
          checked = parseInt(checked, 0) + 1;
        } else {
          checked = '1';
        }

        imageSkeleton.dataset.checked = checked;

        if (checked === 2 && size && productIds) {
          const payload = {
            action: 'lnda_palette_builder_get_screenshot',
            size,
            product_ids: productIds.split(','),
          };

          jQuery.post(translation.ajaxurl, payload, () => {
            buildImagesFromSkeleton();
          });
        }

        const http = new XMLHttpRequest();
        http.open('HEAD', file, false);
        http.send();

        if (http.status !== 404) {
          const newImage = document.createElement('img');
          newImage.src = `${window.location.origin}${file}`;
          newImage.className = 'image-loaded-skeleton';
          newImage.style.height = '90px';
          imageSkeleton.parentNode.replaceChild(newImage, imageSkeleton);
        }
      });
    }
  };
  buildImagesFromSkeleton();
  setInterval(buildImagesFromSkeleton, 8000);


  const LNDAPaletteBuilderImageGenerator = () => {
    const saveButton = document.querySelector('#save-button');

    const fireImageGenerator = () => {
      const items = Array.from(document.querySelectorAll('.price-summary .added-item'));
      const { size } = document.querySelector('.size-option-wrapper .choose-size.selected').dataset;
      const productIds = [];

      if (items) {
        items.forEach((item) => {
          const { productId } = item.dataset;
          productIds.push(productId);
        });
      }

      const payload = {
        action: 'lnda_palette_builder_get_screenshot',
        size,
        product_ids: productIds,
      };

      jQuery.post(translation.ajaxurl, payload, () => {
        buildImagesFromSkeleton();
      });
    };

    saveButton.addEventListener('click', (event) => {
      event.preventDefault();

      const popupWrapper = document.querySelector('.palette-builder-save-popup-wrapper');

      if (popupWrapper) {
        fireImageGenerator();

        const items = Array.from(document.querySelectorAll('.price-summary .added-item'));
        const { size } = document.querySelector('.size-option-wrapper .choose-size.selected').dataset;
        const productIds = [];

        if (items) {
          items.forEach((item) => {
            const { productId } = item.dataset;
            productIds.push(productId);
          });
        }

        const skeleton = popupWrapper.querySelector('.skeleton-box.skeleton-image');

        if (skeleton) {
          skeleton.dataset.file = `/wp-content/uploads/lnda-palettes/${size}-${productIds.join('-')}.png`;
        } else {
          const imageSkeleton = popupWrapper.querySelector('img.image-loaded-skeleton');

          if (imageSkeleton) {
            const newSkeleton = document.createElement('div');

            newSkeleton.className = 'skeleton-box skeleton-image';
            newSkeleton.style.width = '100px';
            newSkeleton.style.height = '90px';
            newSkeleton.dataset.file = `/wp-content/uploads/lnda-palettes/${size}-${productIds.join('-')}.png`;
            imageSkeleton.parentNode.replaceChild(newSkeleton, imageSkeleton);
          }
        }
      }
    });
  };
  LNDAPaletteBuilderImageGenerator();


  const shareButton = () => {
    const button = document.querySelector('#palette-builder-share-copy-link');
    if (button) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const urlField = document.querySelector('#palette-builder-share-url-field');

        if (!navigator.clipboard) {
          button.remove();
          return;
        }

        navigator.clipboard.writeText(urlField.value).then(() => {
          button.classList.add('copied');
          const textOutput = button.querySelector('.text');
          textOutput.innerText = textOutput.dataset.copied;

          setTimeout(() => {
            button.classList.remove('copied');
            textOutput.innerText = textOutput.dataset.text;
          }, 3000);
        }, (err) => {
          console.error('Async: Could not copy text: ', err);
        });
      });
    }
  };


  const initLoad = () => {
    const url = new URL(document.URL);
    const size = url.searchParams.get('size');
    const shades = url.searchParams.get('shades');

    if (size !== null) {
      const sizeButton = document.querySelector(`.size-option-wrapper .choose-size.${size}-size`);
      if (sizeButton) {
        sizeButton.click();
      }
    }

    if (shades !== null) {
      shades.split(',').forEach((shadeId) => {
        const shade = document.querySelector(`.palette-items [data-product-id="${shadeId}"]`);
        if (shade) {
          shade.click();
        }
      });

      shades.split('%2C').forEach((shadeId) => {
        const shade = document.querySelector(`.palette-items [data-product-id="${shadeId}"]`);
        if (shade) {
          shade.click();
        }
      });

      setTimeout(() => {
        url.searchParams.delete('size');
        url.searchParams.delete('shades');
        // eslint-disable-next-line no-restricted-globals
        history.replaceState({}, document.title, url.toString());
      }, 5000);

      setLocalStorage();

      return;
    }

    shareButton();
    getLocalStorage();
  };
  setTimeout(initLoad, 20);


  const setActiveShades = () => {
    const currentActive = Array.from(document.querySelectorAll('.palette-items .palette-item.active'));
    if (currentActive) {
      currentActive.forEach((activeShade) => {
        activeShade.classList.remove('active');
      });
    }

    const activeShades = Array.from(document.querySelectorAll('.slot-group .slot:not(.empty,.large-second)'));
    activeShades.forEach((shade) => {
      const { productId } = shade.dataset;

      const findShade = document.querySelector(`.palette-items .palette-item[data-product-id="${productId}"]`);
      if (findShade) {
        findShade.classList.add('active');
      }
    });
  };


  const updatePrice = (element, amount) => {
    const currency = element.children[0];
    element.removeChild(currency);
    element.innerText = `${amount} `;
    element.appendChild(currency);
  };


  const isValidForDiscount = () => {
    const freeSlots = slots();
    const size = document.querySelector('.choose-size.selected');
    const { discount, discountType } = size.dataset;

    if (freeSlots.length !== 0) {
      return false;
    }

    if (!discount) {
      return false;
    }

    if (!discountType) {
      return false;
    }

    return true;
  };

  const getDiscount = () => {
    const size = document.querySelector('.choose-size.selected');
    const { discount, discountType } = size.dataset;

    return {
      amount: discount,
      type: discountType,
    };
  };


  const buildDiscountRow = () => {
    const row = document.querySelector('.price-summary .discount');
    const col = row.querySelector('.amount');
    const discount = getDiscount();

    row.classList.remove('hidden');

    if (discount.type === 'fixed') {
      col.innerText = `${discount.amount} ${translation.products.currency_symbol}`;
    } else {
      col.innerText = `${discount.amount}%`;
    }
  };


  const buildDiscountTip = () => {
    const discount = getDiscount();
    const discountInfo = document.querySelector('.summary-box .discount-info-indicator');
    if (discount.amount && !isValidForDiscount()) {
      const discountTipOutput = discountInfo.querySelector('.amount');
      if (discount.type === 'fixed') {
        discountTipOutput.innerText = `${discount.amount} ${translation.products.currency_symbol}`;
      } else {
        discountTipOutput.innerText = `${discount.amount}%`;
      }
      discountInfo.classList.remove('hidden');
    } else {
      discountInfo.classList.add('hidden');
    }
  };
  buildDiscountTip();


  const clearDiscountRow = () => {
    const row = document.querySelector('.price-summary .discount');
    if (row.classList.contains('hidden')) {
      return;
    }

    row.classList.add('hidden');

    const col = row.querySelector('.amount');
    col.innerText = 'N/A';
  };


  const summaryCalculateTotals = () => {
    isValidForDiscount();
    setActiveShades();

    if (isValidForDiscount()) {
      buildDiscountRow();
    } else {
      clearDiscountRow();
    }

    buildDiscountTip();

    const pricesContainers = Array.from(document.querySelectorAll('ul.price-summary li:not(.total-price) .price'));
    const totalPriceContainer = document.querySelector('ul.price-summary li.total-price .price');

    let total = 0;
    pricesContainers.forEach((container) => {
      const { price } = container.dataset;
      total += parseInt(price, 0);
    });

    if (isValidForDiscount()) {
      const discount = getDiscount();
      let discountedPrice = total;

      if (discount.type === 'fixed') {
        discountedPrice = total - discount.amount;
      } else {
        discountedPrice = total - ((discount.amount / 100) * total);
      }
      totalPriceContainer.querySelector('.discounted-price').classList.remove('hidden');
      totalPriceContainer.querySelector('.normal-price').classList.add('hidden');

      updatePrice(totalPriceContainer.querySelector('del .amount'), total);
      updatePrice(totalPriceContainer.querySelector('ins .amount'), Math.round(discountedPrice));
      // totalPriceContainer.querySelector('del').innerText = `kr ${total}`;
      // totalPriceContainer.querySelector('ins').innerText = `kr ${Math.round(discountedPrice)}`;
    } else {
      totalPriceContainer.querySelector('.discounted-price').classList.add('hidden');
      totalPriceContainer.querySelector('.normal-price').classList.remove('hidden');
      updatePrice(totalPriceContainer.querySelector('.normal-price .amount'), total);
      // totalPriceContainer.querySelector('.normal-price').innerText = `kr ${total}`;
    }

    setLocalStorage();
    checkIfItemsAdded();
  };
  summaryCalculateTotals();


  const checkIfCategoryIsOpen = () => {
    const categories = document.querySelector('.item-categories');
    categories.classList.remove('is-open');

    if (categories.querySelector('.item-category.selected')) {
      categories.classList.add('is-open');
    }
  };


  const toggleItemCategories = () => {
    const toggleList = document.querySelector('.palette-items-heading');
    toggleList.addEventListener('click', (event) => {
      toggleList.parentNode.classList.toggle('open');
      document.body.classList.toggle('palette-toggle-is-open');

      const current = document.querySelector('.item-categories .item-category.selected');
      if (current) {
        current.classList.remove('selected');
      }

      checkIfCategoryIsOpen();
    });

    const categoryToggles = Array.from(document.querySelectorAll('.item-categories .item-category .category-info'));
    categoryToggles.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const row = button.parentNode;

        const current = document.querySelector('.item-categories .item-category.selected');
        if (current && current !== row) {
          current.classList.remove('selected');
        }

        row.classList.toggle('selected');

        checkIfCategoryIsOpen();
      });
    });
  };
  toggleItemCategories();


  const initAddToCart = () => {
    const button = document.getElementById('add-palette-to-cart');
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const ids = [];
      button.innerText = translation.products.adding_to_cart;
      const box = document.querySelector('ul.price-summary li.box-price');
      if (box) {
        ids.push(box.dataset.productId);
      }
      const items = Array.from(document.querySelectorAll('ul.price-summary li.added-item'));
      if (items) {
        items.forEach((row) => {
          ids.push(row.dataset.productId);
        });
      }

      const payload = {
        action: 'lnda_palette_builder_add_to_cart',
        product_id: document.body.dataset.postId,
        product_ids: ids,
        validDiscount: isValidForDiscount(),
        discount: getDiscount(),
      };

      jQuery.post(translation.ajaxurl, payload, (response) => {
        if (response.success === false) {
          button.innerText = translation.products.add_to_cart;
          alert(translation.products.palette_builder.missing_price);
        } else {
          jQuery(document.body).trigger('wc_fragment_refresh');
          button.innerText = translation.products.added_to_cart;
          setTimeout(() => {
            button.innerText = translation.products.add_to_cart;
          }, 5000);
        }
      });
    });
  };
  initAddToCart();


  const maybeClearAddHere = () => {
    const slot = document.querySelector('.slot.add-palette-here');
    if (slot) {
      slot.classList.remove('add-palette-here');
    }
  };


  const buildCategoryTitleImage = () => {
    const groups = Array.from(document.querySelectorAll('.item-categories .item-category'));
    groups.forEach((group) => {
      const { image } = group.querySelector('ul.palette-items button').dataset;
      const tempImage = group.querySelector('.category-info img');
      tempImage.src = image;
    });
  };
  buildCategoryTitleImage();


  const buildSummaryItemList = () => {
    maybeClearAddHere();
    setActiveShades();

    const existingRows = Array.from(document.querySelectorAll('.price-summary li.added-item'));
    existingRows.forEach((row) => {
      row.remove();
    });

    const filledSlots = Array.from(document.querySelectorAll('.palette-box .slot:not(.empty,.large-second)'));
    const summary = document.querySelector('.price-summary');

    filledSlots.forEach((slot) => {
      const {
        niceName, price, addedId, productId,
      } = slot.dataset;
      const summaryRowClone = document.querySelector('.clone-me').cloneNode(true);
      summaryRowClone.querySelector('.name').innerText = niceName;
      updatePrice(summaryRowClone.querySelector('.price .amount'), price);
      //      summaryRowClone.querySelector('.price').innerText = `kr ${price}`;
      summaryRowClone.querySelector('.price').dataset.price = price;
      summaryRowClone.dataset.productId = productId;
      summaryRowClone.dataset.addedId = addedId;

      summaryRowClone.classList = `added-item id-${addedId}`;

      const deleteButton = summaryRowClone.querySelector('.remove-item');
      deleteButton.addEventListener('click', (event) => {
        event.preventDefault();
        const { addedId: deletedAddedId } = deleteButton.parentNode.dataset;
        const slotToClear = document.querySelector(`.slot[data-added-id="${deletedAddedId}"]`);
        if (slotToClear) {
          slotToClear.querySelector('.clear').click();
        }
      });

      summary.appendChild(summaryRowClone);
    });

    summaryCalculateTotals();
  };


  const buildFilterPaletteList = () => {
    // filter-items-button
    const categories = Array.from(document.querySelectorAll('ul.item-categories .item-category'));
    categories.forEach((category) => {
      const filterButtons = Array.from(category.querySelectorAll('.filter-items-button'));
      filterButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const { filterBy } = button.dataset;
          const items = Array.from(category.querySelectorAll('ul.palette-items > li'));

          category.querySelector('.filter-items-button.active').classList.remove('active');
          button.classList.add('active');

          // Clear all
          items.forEach((item) => {
            item.classList.remove('hidden');
          });

          if (filterBy !== 'all') {
            items.forEach((item) => {
              if (!item.classList.contains(filterBy)) {
                item.classList.add('hidden');
              }
            });
          }
        });
      });
    });
  };
  buildFilterPaletteList();


  const initSlotPlus = () => {
    const buttons = Array.from(document.querySelectorAll('.toggle-add-item'));
    const toggleList = document.querySelector('.palette-items-heading');
    buttons.forEach((button) => {
      const togglePlusIcon = (event) => {
        event.preventDefault();

        if (toggleList) {
          button.parentNode.classList.add('add-palette-here');

          if (!toggleList.parentNode.classList.contains('open')) {
            toggleList.click();
          }
        }
      };

      button.removeEventListener('click', togglePlusIcon, false);

      button.addEventListener('click', togglePlusIcon, false);
    });
  };
  initSlotPlus();


  function removeClassByPrefix(node, prefix) {
    const regx = new RegExp(`\\b${prefix}[^ ]*[ ]?\\b`, 'g');
    node.className = node.className.replace(regx, '');
    return node;
  }


  const renameSlotSizes = (hideAll = false) => {
    const getAllSlots = Array.from(document.querySelectorAll('.slot-item .slot'));
    getAllSlots.forEach((slot) => {
      const { group } = slot.parentNode.parentNode.dataset;
      removeClassByPrefix(slot, 'palette-size-');

      if (hideAll) {
        slot.classList.add('hidden');
      }

      slot.classList.add(`palette-size-${group}`);
    });
  };


  const checkLargeSlots = () => {
    const allSlots = Array.from(document.querySelectorAll('.slot:not(.hidden)'));
    allSlots.forEach((slot) => {
      slot.classList.remove('support-large', 'is-top', 'support-right');
    });

    const slotGroups = Array.from(document.querySelectorAll('.slot-group'));
    slotGroups.forEach((group) => {
      const groupSlots = Array.from(group.querySelectorAll('.slot:not(.hidden)'));
      if (groupSlots[0]) {
        groupSlots[0].classList.add('support-large', 'is-top');
      }

      if (groupSlots[1]) {
        groupSlots[1].classList.remove('support-large');
        if (!groupSlots[1].classList.contains('empty')) {
          groupSlots[0].classList.remove('support-large');
        }
      }

      if (group.nextElementSibling && !group.nextElementSibling.classList.contains('hidden')) {
        const nextGroupSlots = Array.from(group.nextElementSibling.querySelectorAll('.slot:not(.hidden)'));
        if (nextGroupSlots[0]) {
          if (groupSlots[0] && nextGroupSlots[0].classList.contains('empty')) {
            groupSlots[0].classList.add('support-right');
          }
        }

        if (nextGroupSlots[1]) {
          if (groupSlots[1] && nextGroupSlots[1].classList.contains('empty')) {
            groupSlots[1].classList.add('support-right');
          }
        }
      }
    });
  };
  checkLargeSlots();


  const chooseSize = () => {
    const sizesButtons = Array.from(document.querySelectorAll('.choose-size'));

    sizesButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const {
          size, sizes, niceName, price, productId, discount, discountType,
        } = button.dataset;
        const box = document.querySelector('.palette-box');

        // Exit if active size
        if (box.classList.contains(size)) {
          return;
        }

        renameSlotSizes(true);

        // const discountInfo = document.querySelector('.summary-box .discount-info-indicator');
        // if (discount) {
        //  const discountTipOutput = discountInfo.querySelector('.amount');
        //  if (discountType === 'fixed') {
        //    discountTipOutput.innerText = `${discount} ${translation.products.currency_symbol}`;
        //  } else {
        //    discountTipOutput.innerText = `${discount}%`;
        //  }
        //  discountInfo.classList.remove('hidden');
        // } else {
        //  discountInfo.classList.add('hidden');
        // }

        document.querySelector('.choose-size.selected').classList.remove('selected');
        button.classList.add('selected');

        box.classList = `palette-box ${size}`;

        const listSizes = sizes.split(' ');

        listSizes.forEach((classname) => {
          const sizeSlots = Array.from(document.querySelectorAll(`.palette-size-${classname}`));

          sizeSlots.forEach((slot) => {
            slot.classList.remove('hidden');
          });
        });

        const hiddenSlots = Array.from(document.querySelectorAll('.slot.hidden'));
        hiddenSlots.forEach((hiddenSlot) => {
          const { baseClass } = hiddenSlot.parentNode.parentNode.dataset;
          if (hiddenSlot.classList.contains('large-horizontal-second')) {
            if (hiddenSlot.classList.contains('is-top')) {
              hiddenSlot.parentNode.parentNode.previousSibling.firstElementChild.firstElementChild.querySelector('.clear').click();
            }

            if (!hiddenSlot.classList.contains('is-top')) {
              hiddenSlot.parentNode.parentNode.previousSibling.lastElementChild.firstElementChild.querySelector('.clear').click();
            }
          }
          hiddenSlot.className = baseClass;
          hiddenSlot.style = '';
          hiddenSlot.querySelector('img.slot-palette-item').src = '';
        });

        const summaryRow = document.querySelector('ul.price-summary .box-price');
        summaryRow.dataset.productId = productId;
        summaryRow.querySelector('.name').innerText = niceName;
        updatePrice(summaryRow.querySelector('.price .amount'), price);
        summaryRow.querySelector('.price').dataset.price = price;

        renameSlotSizes();
        buildSummaryItemList();
        checkLargeSlots();
      });
    });
  };
  chooseSize();


  const clearButtons = () => {
    const buttons = Array.from(document.querySelectorAll('.slot .clear'));
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const slot = button.parentNode;
        const { addedId } = slot.dataset;

        if (slot.classList.contains('large') && slot.classList.contains('is-horizontal')) {
          if (slot.classList.contains('is-top')) {
            slot.parentNode.parentNode.nextElementSibling.firstElementChild.firstElementChild.classList = slot.parentNode.parentNode.dataset.baseClass;
            slot.parentNode.parentNode.nextElementSibling.firstElementChild.firstElementChild.classList.remove('hidden');
          } else if (!slot.classList.contains('is-top')) {
            slot.parentNode.parentNode.nextElementSibling.lastElementChild.firstElementChild.classList = slot.parentNode.parentNode.dataset.baseClass;
            slot.parentNode.parentNode.nextElementSibling.lastElementChild.firstElementChild.classList.remove('hidden');
          }
        } else if (slot.classList.contains('large') && !slot.classList.contains('is-horizontal')) {
          slot.parentNode.nextElementSibling.firstElementChild.classList = slot.parentNode.parentNode.dataset.baseClass;
          slot.parentNode.nextElementSibling.firstElementChild.classList.remove('hidden');
        }

        const summaryRow = document.querySelector(`.price-summary .id-${addedId}`);
        if (summaryRow) {
          summaryRow.remove();
        }

        slot.classList = slot.parentNode.parentNode.dataset.baseClass;
        slot.classList.remove('hidden');
        slot.dataset.addedId = '';
        slot.dataset.productId = '';
        slot.style = '';
        slot.querySelector('img.slot-palette-item').src = '';
        checkLargeSlots();
        summaryCalculateTotals();
      });
    });
  };
  clearButtons();


  paletteItems().forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();

      const {
        size, niceName, price, image, productId,
      } = item.dataset;
      const id = Math.floor(Math.random() * 999999999) + 1;

      if (size === '1') {
        const freeSlots = slots();

        if (!freeSlots[0]) {
          alert(translation.products.palette_builder.full);
          return;
        }

        const slot = document.querySelector('.slot.add-palette-here');
        if (slot) {
          freeSlots[0] = slot;
        }

        freeSlots[0].querySelector('img.slot-palette-item').src = image;
        freeSlots[0].classList.remove('empty');
        // freeSlots[0].style.backgroundImage = `url('${image}')`;
        freeSlots[0].dataset.addedId = id;
        freeSlots[0].dataset.productId = productId;
        freeSlots[0].dataset.niceName = niceName;
        freeSlots[0].dataset.price = price;
      }

      if (size === '2') {
        const freeSlots = slots('.support-large');
        let canBeVertical = true;
        let added = false;

        if (!freeSlots[0]) {
          canBeVertical = false;
        }

        if (canBeVertical) {
          if (!freeSlots[0].parentNode.nextElementSibling.firstElementChild.classList.contains('empty')) {
            canBeVertical = false;
          }
        }

        if (canBeVertical) {
          freeSlots[0].querySelector('img.slot-palette-item').src = image;

          freeSlots[0].classList.remove('empty');
          freeSlots[0].classList.add('large');
          freeSlots[0].dataset.addedId = id;
          freeSlots[0].dataset.productId = productId;
          freeSlots[0].dataset.niceName = niceName;
          freeSlots[0].dataset.price = price;

          freeSlots[0].parentNode.nextElementSibling.firstElementChild.classList.remove('empty');
          freeSlots[0].parentNode.nextElementSibling.firstElementChild.classList.add('large-second');

          added = true;
        }

        if (!added && !canBeVertical) {
          const freeSlotsRight = slots('.support-right');
          if (freeSlotsRight[0]) {
            freeSlotsRight[0].querySelector('img.slot-palette-item').src = image;

            freeSlotsRight[0].classList.remove('empty');
            freeSlotsRight[0].classList.add('large');
            freeSlotsRight[0].classList.add('is-horizontal');
            freeSlotsRight[0].dataset.addedId = id;
            freeSlotsRight[0].dataset.productId = productId;
            freeSlotsRight[0].dataset.niceName = niceName;
            freeSlotsRight[0].dataset.price = price;

            if (freeSlotsRight[0].classList.contains('is-top')) {
              freeSlotsRight[0].parentNode.parentNode.nextElementSibling.firstElementChild.firstElementChild.classList.remove('empty');
              freeSlotsRight[0].parentNode.parentNode.nextElementSibling.firstElementChild.firstElementChild.classList.add('large-second');
              freeSlotsRight[0].parentNode.parentNode.nextElementSibling.firstElementChild.firstElementChild.classList.add('large-horizontal-second');
            } else {
              freeSlotsRight[0].parentNode.parentNode.nextElementSibling.lastElementChild.firstElementChild.classList.remove('empty');
              freeSlotsRight[0].parentNode.parentNode.nextElementSibling.lastElementChild.firstElementChild.classList.add('large-second');
              freeSlotsRight[0].parentNode.parentNode.nextElementSibling.lastElementChild.firstElementChild.classList.add('large-horizontal-second');
            }

            added = true;
          }
        }

        if (!added) {
          alert(translation.products.palette_builder.full);
          return;
        }
      }

      checkLargeSlots();
      buildSummaryItemList();
    });
  });


  const initStartButton = () => {
    const startButton = document.querySelector('#start-building-button');
    if (startButton) {
      startButton.addEventListener('click', (event) => {
        event.preventDefault();
        document.body.classList.remove('first-timer');
        const toggleButton = document.querySelector('.palette-items-heading');
        if (toggleButton) {
          toggleButton.click();
        }
      });
    }
  };
  initStartButton();


  const clearAllVisiblePallets = () => {
    const AllClearButtons = Array.from(document.querySelectorAll('.slot-item .slot:not(.hidden) .clear'));
    if (AllClearButtons) {
      AllClearButtons.forEach((clearButton) => {
        clearButton.click();
      });
    }
  };


  const buildPackageButton = (button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const { productIds, size } = button.dataset;
      const sizeButton = document.querySelector(`.size-option-wrapper .choose-size.${size}-size`);

      clearAllVisiblePallets();

      if (sizeButton) {
        sizeButton.click();
      }

      if (productIds) {
        productIds.split(',').forEach((id) => {
          const shade = document.querySelector(`.palette-item[data-product-id="${id}"]`);
          if (shade) {
            shade.click();
          }
        });
      }
    });
  };

  const buildPackageInserts = () => {
    const packageButtons = Array.from(document.querySelectorAll('.item-category-stored-packaged .palette-item-package'));
    packageButtons.forEach((button) => {
      buildPackageButton(button);
    });
  };
  buildPackageInserts();


  const deleteUserPaletteButton = () => {
    const deleteButtons = Array.from(document.querySelectorAll('.palette-items.package-list .delete-saved-packaged'));
    if (deleteButtons) {
      deleteButtons.forEach((button) => {
        const { id, name } = button.dataset;
        button.addEventListener('click', (event) => {
          event.preventDefault();

          // eslint-disable-next-line no-restricted-globals
          if (confirm(`Ønsker du å slette «${name}»?`) !== true) {
            return;
          }

          const payload = {
            action: 'lnda_palette_builder_user_delete_palette',
            id,
          };

          const liElement = button.parentNode;
          liElement.classList.add('loading');

          jQuery.post(translation.ajaxurl, payload, (response) => {
            liElement.classList.remove('loading');

            if (response.success) {
              liElement.remove();
            } else {
              alert('Error deleting');
            }
          });
        });
      });
    }
  };
  deleteUserPaletteButton();


  const toggleSavePalettePopup = () => {
    const button = document.querySelector('#save-button');
    const popupContainer = document.querySelector('.palette-builder-save-popup-wrapper');

    button.addEventListener('click', (event) => {
      event.preventDefault();
      popupContainer.classList.toggle('hidden');

      const nameField = popupContainer.querySelector('input[name="palette-name"]');
      if (nameField) {
        setTimeout(() => {
          nameField.value = '';
          nameField.focus();
        }, 100);
      }
    });

    const closeButton = popupContainer.querySelector('.close-save-popup');
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      popupContainer.classList.toggle('hidden');
    });
  };
  toggleSavePalettePopup();


  const toggleSharePalettePopup = () => {
    const popupContainer = document.querySelector('.palette-builder-share-popup-wrapper');
    const buttons = Array.from(document.querySelectorAll('.toggle-share-popup'));

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        popupContainer.classList.toggle('hidden');
      });
    });
  };
  toggleSharePalettePopup();


  const savePaletteButton = () => {
    const saveForm = document.querySelector('.save-palette-form');

    if (!saveForm) {
      return;
    }

    const button = saveForm.querySelector('.button');
    if (!button) {
      return;
    }

    let isSaving = false;
    saveForm.addEventListener('submit', (event) => {
      event.preventDefault();

      if (isSaving) {
        return;
      }

      isSaving = true;

      button.innerText = 'Lagrer…';
      button.classList.add('loading');
      const items = Array.from(document.querySelectorAll('.price-summary .added-item'));
      const { size } = document.querySelector('.size-option-wrapper .choose-size.selected').dataset;
      const name = document.querySelector('.save-palette-form input[name="palette-name"]').value;
      const productIds = [];

      if (items) {
        items.forEach((item) => {
          const { productId } = item.dataset;
          productIds.push(productId);
        });
      }

      const payload = {
        action: 'lnda_palette_builder_user_save',
        product_ids: productIds,
        name,
        size,
      };

      const existingRow = document.querySelector('.item-category-stored-packaged ul.palette-items');

      jQuery.post(translation.ajaxurl, payload, (response) => {
        existingRow.innerHTML = response;
        button.innerText = 'Lagret';
        button.classList.remove('loading');
        isSaving = false;

        const popupContainer = document.querySelector('.palette-builder-save-popup-wrapper');
        popupContainer.classList.add('hidden');

        jQuery(document.body).trigger('lnda_palette_builder_saved');

        buildPackageInserts();
        deleteUserPaletteButton();

        setTimeout(() => {
          button.innerText = 'Lagre';
        }, 3000);
      });
    });
  };
  savePaletteButton();


  document.addEventListener('DOMContentLoaded', (event) => {
    let dragSrcEl = null;

    function handleDragStart(e) {
      this.style.opacity = '1';
      this.style.cursor = 'grabbing';
      this.classList.add('is-grabbing');

      dragSrcEl = this;

      if (this.firstElementChild.classList.contains('large') && !this.firstElementChild.classList.contains('is-horizontal')) {
        document.querySelectorAll('.slot-item .slot:not(.large-horizontal-second)').forEach((slot) => {
          if (dragSrcEl.querySelector('.slot') !== slot) {
            if (!slot.classList.contains('is-top') && !slot.classList.contains('is-horizontal')) {
              return;
            }

            if (slot.parentNode.nextElementSibling && slot.parentNode.nextElementSibling.firstElementChild.classList.contains('is-horizontal')) {
              return;
            }

            if (slot.parentNode.nextElementSibling && slot.parentNode.nextElementSibling.firstElementChild.classList.contains('large-horizontal-second')) {
              return;
            }

            if (!slot.classList.contains('is-horizontal')) {
              slot.classList.add('can-move-to', 'moving-large');
              slot.parentNode.nextElementSibling.firstElementChild.classList.add('hide-when-dragging-large');
            }
          }
        });
      } else if (this.firstElementChild.classList.contains('large') && this.firstElementChild.classList.contains('is-horizontal')) {
        document.querySelectorAll('.slot-item .slot.is-horizontal').forEach((slot) => {
          if (dragSrcEl.querySelector('.slot') === slot) {
            slot.classList.add('is-old-large-horizontal');
            return;
          }

          slot.classList.add('can-move-to', 'moving-large');
          // slot.parentNode.nextElementSibling.firstElementChild.classList.add('hide-when-dragging-large');
        });
      } else {
        document.querySelectorAll('.slot-item .slot').forEach((slot) => {
          if (dragSrcEl.querySelector('.slot') === slot) {
            return;
          }

          if (dragSrcEl.firstElementChild.classList.contains('is-top')) {
            if (slot.classList.contains('large')) {
              if (dragSrcEl.parentNode.lastElementChild.firstElementChild.classList.contains('is-horizontal')) {
                return;
              }

              if (dragSrcEl.parentNode.lastElementChild.firstElementChild.classList.contains('large-horizontal-second')) {
                return;
              }
            }
          }

          if (!dragSrcEl.firstElementChild.classList.contains('is-top')) {
            if (slot.classList.contains('large')) {
              if (dragSrcEl.parentNode.firstElementChild.firstElementChild.classList.contains('is-horizontal')) {
                return;
              }

              if (dragSrcEl.parentNode.firstElementChild.firstElementChild.classList.contains('large-horizontal-second')) {
                return;
              }
            }
          }

          if (slot.classList.contains('is-horizontal')) {
            return;
          }

          if (slot.classList.contains('large-horizontal-second')) {
            return;
          }

          slot.classList.add('can-move-to');
        });
      }

      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/html', this.innerHTML);
    }


    const items = document.querySelectorAll('.slot-item');

    function handleDragOver(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      e.dataTransfer.dropEffect = 'move';

      return false;
    }

    function handleDragEnter(e) {
      this.classList.add('over');
    }

    function handleDragLeave(e) {
      this.classList.remove('over');
    }

    function handleDropOnLarge(dropped, moved) {
      const newTop = moved.parentNode.querySelector('.slot-item');
      const oldBottom = dropped.nextElementSibling;
      const tempNewTop = newTop.innerHTML;
      const tempOldBottom = oldBottom.innerHTML;

      newTop.innerHTML = moved.innerHTML;
      moved.innerHTML = tempOldBottom;
      oldBottom.innerHTML = dropped.innerHTML;
      dropped.innerHTML = tempNewTop;
    }

    function handleDragEnd(e) {
      setTimeout(() => {
        this.style.opacity = '1';
        this.classList.remove('is-grabbing');

        document.querySelectorAll('.slot-item .slot').forEach((slot) => {
          slot.classList.remove('can-move-to', 'moving-large', 'is-old-large-horizontal', 'hide-when-dragging-large');
          slot.style.borderColor = '';
        });

        items.forEach((item) => {
          item.classList.remove('over');
        });

        slots();
        initSlotPlus();
      }, 20);
    }


    function handleDrop(e) {
      if (e.stopPropagation) {
        e.stopPropagation(); // stops the browser from redirecting.
      }

      if (dragSrcEl === this) {
        return false;
      }

      if (this.nextElementSibling && this.nextElementSibling.classList.contains('is-horizontal')) {
        return false;
      }

      if (!this.firstElementChild.classList.contains('can-move-to')) {
        return false;
      }

      if (dragSrcEl !== this) {
        dragSrcEl.innerHTML = this.innerHTML;
        this.innerHTML = e.dataTransfer.getData('text/html');
      }

      // Removes meta-data from the DOM if inserted (chromium)
      if (this.querySelector('meta') !== null) {
        this.querySelector('meta').remove();
      }

      if (this.firstElementChild.classList.contains('large')) {
        if (this.firstElementChild && this.firstElementChild.classList.contains('is-horizontal')) {
          // this.parentNode.nextElementSibling.firstElementChild.appendChild(dragSrcEl.parentNode.nextElementSibling.lastElementChild.firstElementChild);
          // dragSrcEl.parentNode.nextElementSibling.lastElementChild.appendChild(this.parentNode.nextElementSibling.firstElementChild.firstElementChild);
        } else {
          this.nextElementSibling.appendChild(dragSrcEl.nextElementSibling.firstElementChild);
          dragSrcEl.nextElementSibling.appendChild(this.nextElementSibling.firstElementChild);
        }
      } else if (dragSrcEl.nextElementSibling) {
        if (dragSrcEl.firstElementChild.classList.contains('large')) {
          this.nextElementSibling.appendChild(dragSrcEl.nextElementSibling.firstElementChild);
          dragSrcEl.nextElementSibling.appendChild(this.nextElementSibling.firstElementChild);
        }
      } else if (dragSrcEl.firstElementChild.classList.contains('large')) {
        handleDropOnLarge(this, dragSrcEl);
      }

      renameSlotSizes();
      checkLargeSlots();
      clearButtons();
      buildSummaryItemList();

      return false;
    }


    items.forEach((item) => {
      item.addEventListener('dragstart', handleDragStart, false);
      item.addEventListener('dragenter', handleDragEnter, false);
      item.addEventListener('dragover', handleDragOver, false);
      item.addEventListener('dragleave', handleDragLeave, false);
      item.addEventListener('drop', handleDrop, false);
      item.addEventListener('dragend', handleDragEnd, false);
    });
  });
};


if (document.body.classList.contains('product-type-lnda-palette-builder')) {
  paletteBuilder();
}
